import { Geography } from '@node/wam-audience-builder'
import { toNumber, join, deburr, toLower } from 'lodash'


export default {
    commitError: (commit, action, error) => {
        commit(
            action,
            {
                type: 'error',
                message: error.message
            },
            { root: true }
        )
        throw error
    },

    buildRoutes: country_id => {
        const route = '/common_project/division1s/detail/json'
        const params = {
            params: {
                list_limit: 0,
                is_flat: 1,
                conditions: {
                    country_id,
                    label: ['-and', { '!=': 'aol' }, { '!=': 'unknown' }, { '-not_like': '%(old)%' }]
                }
            }
        }
        return { route, params }
    },

    parseData: (data, countryId) => {
        const _data = []
        for (const val of data) {
            const wamData = {
                id: toNumber(val.id),
                label: val.label,
                isSelectable: true,
                hasChild: !val.division1_id ? true : false,
                parentJsonKeyName: !val.division1_id ? null : join(['division1', countryId, val.division1_id], '_'),
                jsonKey: {
                    name: val.division1_id ? join(['division2', countryId, val.id], '_') : join(['division1', countryId, val.id], '_'),
                    type: val.division1_id ? 'Division2' : 'Division1',
                    subType: null,
                    ids: [countryId, toNumber(val.id)]
                }
            }
            _data.push(wamData)
        }
        return _data.sort((a, b) => (toLower(deburr(a.label)) > toLower(deburr(b.label)) ? 1 : toLower(deburr(b.label)) > toLower(deburr(a.label)) ? -1 : 0))
    },

    instanciateAll: (geo, countryCode, countryLabel) => {
        return Geography.createAll(
            geo.map(item => {
                return {
                    id: item.id,
                    label: item.label,
                    path: ['Geography', countryLabel],
                    parentId: item?.division1_id
                        ? Geography.generateCrossId({
                            category: 'Geography',
                            id: item.division1_id
                        })
                        : null,
                    division: item?.division1_id ? 'Division2' : 'Division1',
                    countryCode
                }
            })
        )
    }
}
